import clsx from 'clsx';

import { convertMemberToAuthor } from 'src/tools/member.tools';
import { ifTrue } from 'src/tools/logic.tools';
import { makeRoleName } from 'src/tools/string.tools';
import { t } from 'src/tools/text.tools';

import { MemberResult } from 'src/models/autocomplete.model';

import { Avatar } from 'src/components/Avatar';
import { P3, P4, P5 } from 'src/components/Typography';
import { WarningIconBadge } from 'src/components/IconBadge';

import classes from './MemberResultLine.module.scss';

const TXT = t(['members', 'modal']);

interface Props {
  member: MemberResult;
}

// new-ui
export function MemberResultLine({ member }: Props) {
  function renderAlreadyAssigned() {
    const message = `The user exists as an ${makeRoleName(member.role ?? 'unknown')} in Project`;

    return (
      <div className={clsx('row a-center j-start items-p4', classes.assigned)}>
        <WarningIconBadge isSmall />
        <P5 className={classes['assigned-message']}>{message}</P5>
      </div>
    );
  }

  function renderName() {
    return <P3 className={clsx(classes.name, ifTrue(member.already_assigned, classes.disabled))}>{member.name}</P3>;
  }

  function renderInvite() {
    return (
      <div className={clsx('row j-start', classes.container)}>
        <P3 className={classes.invite}>{TXT('inviteNewUser')}</P3>
      </div>
    );
  }

  if (member.id === 'invite') return renderInvite();

  const containerClasses = clsx(
    'column w-100p a-start j-start',
    classes.container,
    ifTrue(member.already_assigned, classes['disabled-container']),
  );

  return (
    <div className={containerClasses}>
      <div className='row w-100p a-center j-between'>
        <div className={clsx('row a-center j-start', classes.left)}>
          <Avatar isDisabled={member.already_assigned} author={convertMemberToAuthor(member)} />
          {ifTrue(member.name.trimEnd(), renderName, <div className={classes['no-name']} />)}
          <P4 className={classes.grey}>{member.email}</P4>
        </div>
        <P4 className={classes.company}>{member.company}</P4>
      </div>
      {ifTrue(member.already_assigned, renderAlreadyAssigned)}
    </div>
  );
}
